var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOperationLogisticList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 28.9C12.1046 28.9 13 27.9151 13 26.7C13 25.4849 12.1046 24.5 11 24.5C9.89543 24.5 9 25.4849 9 26.7C9 27.9151 9.89543 28.9 11 28.9Z",
    stroke: "#176318",
    strokeWidth: 1.5,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 28.9C22.1046 28.9 23 27.9151 23 26.7C23 25.4849 22.1046 24.5 21 24.5C19.8954 24.5 19 25.4849 19 26.7C19 27.9151 19.8954 28.9 21 28.9Z",
    stroke: "#176318",
    strokeWidth: 1.5,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.05 26.7001H18V15.2601C18 14.8956 17.7314 14.6001 17.4 14.6001H4",
    stroke: "#176318",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.65 26.6999H6.6C6.26863 26.6999 6 26.4044 6 26.0399V20.6499",
    stroke: "#176318",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 17.8999H9",
    stroke: "#176318",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18 17.8999H23.6101C23.8472 17.8999 24.0621 18.0535 24.1584 18.2919L25.9483 22.7219C25.9824 22.8063 26 22.8976 26 22.9899V26.0399C26 26.4044 25.7314 26.6999 25.4 26.6999H23.5",
    stroke: "#176318",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18 26.7002H19",
    stroke: "#176318",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperationLogisticList);
export default __webpack_public_path__ + "static/media/OperationLogisticList.c05e033708e14f6caa7b4e56e6448500.svg";
export { ForwardRef as ReactComponent };